document.addEventListener("DOMContentLoaded", function () {
	const form = document.getElementById("contact-form")
	if (form) {
		form.addEventListener("submit", function (event) {
			event.preventDefault()

			// Validate form before submission
			if (validateForm()) {
				submitForm()
			}
		})
	}

	// Add newsletter form handling
	const newsletterForm = document.getElementById("newsletter-form")
	if (newsletterForm) {
		newsletterForm.addEventListener("submit", function (event) {
			event.preventDefault()
			submitNewsletterForm(this)
		})
	}

	function validateForm() {
		let isValid = true

		// Required fields
		const requiredFields = ["organisation", "firstName", "lastName", "email", "phone", "source"]

		requiredFields.forEach((field) => {
			const element = document.getElementById(field)
			if (!element.value.trim()) {
				markInvalid(element, "This field is required")
				isValid = false
			} else {
				markValid(element)
			}
		})

		// Email validation
		const emailField = document.getElementById("email")
		if (emailField.value.trim() && !isValidEmail(emailField.value)) {
			markInvalid(emailField, "Please enter a valid email address")
			isValid = false
		}

		// Phone validation
		const phoneField = document.getElementById("phone")
		if (phoneField.value.trim() && !isValidPhone(phoneField.value)) {
			markInvalid(phoneField, "Please enter a valid phone number")
			isValid = false
		}

		return isValid
	}

	function isValidEmail(email) {
		const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
		return regex.test(email)
	}

	function isValidPhone(phone) {
		// Basic phone validation, can be adjusted based on requirements
		const regex = /^[+]?[0-9\s()-]{8,20}$/
		return regex.test(phone)
	}

	function markInvalid(element, message) {
		// Add error styling
		element.classList.add("invalid")

		// Show error message
		let errorElement = element.nextElementSibling
		if (!errorElement || !errorElement.classList.contains("error-message")) {
			errorElement = document.createElement("div")
			errorElement.className = "error-message"
			element.parentNode.insertBefore(errorElement, element.nextSibling)
		}
		errorElement.textContent = message
	}

	function markValid(element) {
		// Remove error styling
		element.classList.remove("invalid")

		// Remove error message if exists
		const errorElement = element.nextElementSibling
		if (errorElement && errorElement.classList.contains("error-message")) {
			errorElement.remove()
		}
	}

	function submitForm() {
		// Show loading state
		const submitButton = document.getElementById("submit-btn")
		const originalText = submitButton.textContent
		submitButton.disabled = true
		submitButton.textContent = "Submitting..."

		// Get form data
		const formData = new FormData(form)

		// Convert to JSON if needed
		const formDataJson = Object.fromEntries(formData.entries())

		// Submit form using fetch
		fetch(form.action, {
			method: form.method,
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formDataJson),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not OK")
				}
				return response.json()
			})
			.then((data) => {
				// Show success message
				form.innerHTML =
					'<div class="success-message"><h3>Thank you for your submission!</h3><p>We will get back to you shortly.</p></div>'
			})
			.catch((error) => {
				// Show error message
				console.error("Error:", error)
				const errorDiv = document.createElement("div")
				errorDiv.className = "form-error"
				errorDiv.textContent = "There was an error submitting the form. Please try again later."
				form.prepend(errorDiv)

				// Reset button
				submitButton.disabled = false
				submitButton.textContent = originalText
			})
	}

	function submitNewsletterForm(form) {
		// Show loading state
		const submitButton = form.querySelector('button[type="submit"]')
		const originalText = submitButton.textContent
		submitButton.disabled = true
		submitButton.textContent = "Subscribing..."

		// Get form data
		const formData = new FormData(form)
		const formDataJson = Object.fromEntries(formData.entries())

		// Submit form using fetch
		fetch(form.action, {
			method: form.method,
			headers: {
				"Content-Type": "application/json",
			},
			body: JSON.stringify(formDataJson),
		})
			.then((response) => {
				if (!response.ok) {
					throw new Error("Network response was not OK")
				}
				return response.json()
			})
			.then((data) => {
				// Show success message
				form.innerHTML = '<div class="success-message">Thank you for subscribing!</div>'
			})
			.catch((error) => {
				// Show error message
				console.error("Error:", error)
				const errorDiv = document.createElement("div")
				errorDiv.className = "form-error"
				errorDiv.textContent = "There was an error subscribing. Please try again later."
				form.prepend(errorDiv)

				// Reset button
				submitButton.disabled = false
				submitButton.textContent = originalText
			})
	}
})
